// extracted by mini-css-extract-plugin
export default {"code":"Post_code__YXS9+","copyicon":"Post_copyicon__+JT+4","syntaxHighlighter":"Post_syntaxHighlighter__Qv5gP","postTag":"Post_postTag__u34Sq"};